import { showApiErrors } from '@/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { applyFaqImport, exportFaqs, previewFaqImport } from './actionCreators';
import { FaqImportExportState, SLICE_NAME, initialState } from './models';

export const faqCommonSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setFaqImportFile: (state: FaqImportExportState, action: PayloadAction<File | null>) => {
      state.selectedFile = action.payload;
    },
    resetFaqImport: (state: FaqImportExportState) => {
      state.selectedFile = null;
      state.preview = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(previewFaqImport.pending, (state: FaqImportExportState) => {
        state.isPreviewing = true;
        state.error = null;
      })
      .addCase(previewFaqImport.fulfilled, (state: FaqImportExportState, action) => {
        state.isPreviewing = false;
        state.preview = action.payload;
      })
      .addCase(previewFaqImport.rejected, (state: FaqImportExportState, action) => {
        state.isPreviewing = false;
        state.error = action.error;
        showApiErrors(action.error);
      })
      .addCase(applyFaqImport.pending, (state: FaqImportExportState) => {
        state.isApplying = true;
        state.error = null;
      })
      .addCase(applyFaqImport.fulfilled, (state: FaqImportExportState) => {
        state.isApplying = false;
        state.preview = null;
      })
      .addCase(applyFaqImport.rejected, (state: FaqImportExportState, action) => {
        state.isApplying = false;
        state.error = action.error;
        showApiErrors(action.error);
      })
      .addCase(exportFaqs.pending, (state: FaqImportExportState) => {
        state.isExporting = true;
      })
      .addCase(exportFaqs.fulfilled, (state: FaqImportExportState) => {
        state.isExporting = false;
      })
      .addCase(exportFaqs.rejected, (state: FaqImportExportState, action) => {
        state.isExporting = false;
        state.error = action.error;
        showApiErrors(action.error);
      });
  },
});

export const { setFaqImportFile, resetFaqImport } = faqCommonSlice.actions;
